// libraries
import React from 'react'
import clsx from 'clsx'

// prop types
export interface SectionProps {
    children: React.ReactNode
    noSeparator?: boolean
    bgColor?: 'white' | 'mini' | string
    whiteText?: boolean
    marginTop?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
    marginBottom?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
    className?: string
    id?: string
}

export default function Section({
    bgColor = 'white',
    whiteText,
    marginTop,
    marginBottom,
    children,
    className,
    id
}: SectionProps) {

    // custom bg color
    const customBgColor = bgColor && !['white', 'mini'].includes(bgColor) ? { backgroundColor: bgColor } : {}

    return (
        <section
            id={id}
            className={clsx(
                'section',
                className,

                // margins
                marginTop === 'smaller' && 'margin--top-smaller',
                marginTop === 'small' && 'margin--top-small',
                marginTop === 'medium' && 'margin--top-medium',
                marginTop === 'big' && 'margin--top-big',
                marginTop === 'none' && 'margin--top-none',
                marginBottom === 'smaller' && 'margin--bottom-smaller',
                marginBottom === 'small' && 'margin--bottom-small',
                marginBottom === 'medium' && 'margin--bottom-medium',
                marginBottom === 'big' && 'margin--bottom-big',
                marginBottom === 'none' && 'margin--bottom-none',
            )}
        >

            <div
                className={clsx(
                    'section__wrapper',
                    bgColor != 'mini' && whiteText && 'white',
                    bgColor === 'white' && 'bg-white',
                    bgColor === 'mini' && 'bg-mini'
                )}
                style={customBgColor}
            >
                <div className='relative z2'>
                    {children}
                </div>
            </div>

        </section>
    )
}